import { api } from './client';
import type {
  CancelRequest,
  MarkPaidRequest,
  Order,
  PaymentStatus,
  Refund,
  RefundRequest,
} from '../types';

export interface OrderQuery {
  storeId?: number | null;
  from?: string;
  to?: string;
  q?: string;
  // UNPAID = only completed bills still awaiting payment.
  paymentStatus?: PaymentStatus;
}

export const ordersApi = {
  list: (query: OrderQuery = {}) =>
    api
      .get<Order[]>('/orders', {
        params: {
          storeId: query.storeId ?? undefined,
          from: query.from || undefined,
          to: query.to || undefined,
          q: query.q || undefined,
          paymentStatus: query.paymentStatus || undefined,
        },
      })
      .then((r) => r.data),

  // `id` is the bill number (the public identifier).
  get: (id: string) => api.get<Order>(`/orders/${id}`).then((r) => r.data),

  cancelled: (storeId?: number | null) =>
    api
      .get<Order[]>('/orders/cancelled', {
        params: storeId != null ? { storeId } : undefined,
      })
      .then((r) => r.data),

  cancel: (id: string, body: CancelRequest) =>
    api.post<Order>(`/orders/${id}/cancel`, body).then((r) => r.data),

  // Records the payment for a pay-later (GST) bill; returns the updated bill.
  markPaid: (id: string, body: MarkPaidRequest) =>
    api.post<Order>(`/orders/${id}/mark-paid`, body).then((r) => r.data),

  refund: (id: string, body: RefundRequest) =>
    api.post<Refund>(`/orders/${id}/refund`, body).then((r) => r.data),

  refunds: (storeId?: number | null) =>
    api
      .get<Refund[]>('/refunds', {
        params: storeId != null ? { storeId } : undefined,
      })
      .then((r) => r.data),
};
